import { t } from "i18next";
import Image from "next/image";
import type { FC } from "react";

import { Button } from "../../atoms/Button";
import { format2Dec } from "@utils/number-to-short-version";

export interface DirectRequestBodyProps {
  requestDirectingVoteAccount: string;
  validatorIcon: string;
  amount?: number;
  directingTo: string;
  symbol?: string;
  confirmAction: (voteAccount: string) => void;
}

export const DirectRequestBody: FC<DirectRequestBodyProps> = ({
  validatorIcon,
  directingTo,
  amount,
  confirmAction,
  symbol = "SOL",
  requestDirectingVoteAccount,
}) => {
  return (
    <div className="w-full items-center md:pb-4 px-2 md:px-0">
      <Image
        src={validatorIcon}
        alt="Directed to validator asset icon"
        width={64}
        height={64}
        className="m-auto"
      />
      <p className="text-center mt-8 text-2xl font-semibold">
        {t("governance.about_direct_title")}
      </p>
      <div className="relative mt-4 inline-block translate-x-[-50%] left-[50%]">
        <p className="w-full text-center font-bold text-[56px]">
          {format2Dec(amount ?? 0)}
        </p>
        <span className="absolute top-0 right-0 translate-x-full text-tertiary-text text-xl">
          {symbol}
        </span>
      </div>
      <div className="w-full mt-4">
        <div className="font-semibold text-sm text-secondary-text">
          <span>{t("appPage.transaction-modals.directed-to")}</span>
          <p className="flex gap-2 text-base items-center text-black">
            {directingTo}
          </p>
        </div>
      </div>
      <Button
        variant="primary"
        label={t("governance.confirm_directing")}
        className="w-full mt-4 text-lg py-14-px"
        onClick={() => confirmAction(requestDirectingVoteAccount)}
      />
    </div>
  );
};
